import { useQuery } from '@tanstack/react-query';

interface ExchangeRateResponse {
  rates: {
    TRY: number;
  };
  base: string;
  date: string;
}

export const useExchangeRate = () => {
  return useQuery({
    queryKey: ['exchangeRate', 'USD', 'TRY'],
    queryFn: async (): Promise<number> => {
      // Using exchangerate-api.io (free tier)
      // Alternative: You can use any free exchange rate API
      try {
        const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
        const data: ExchangeRateResponse = await response.json();
        return data.rates.TRY;
      } catch (error) {
        // Fallback to a default rate if API fails
        console.error('Exchange rate API error:', error);
        return 34.5; // Approximate fallback rate
      }
    },
    refetchInterval: 60000, // Refetch every minute
    staleTime: 30000, // Consider data stale after 30 seconds
  });
};

